import { Link } from 'react-router-dom'
import logo from '../assets/groupeouambologo.jpg'
import './Footer.css'

function Footer({ t, year, lang }) {
  const slogan = lang === 'fr' ? 'Holding Technologie et Digitalisation' : 'Technology & Digitalization Holding'
  const description = lang === 'fr'
    ? 'Groupe Ouambo est un groupe de technologie et de digitalisation — plateformes assistées par l\'IA pour l\'éducation, le commerce et les opérations, avec déploiement terrain du Cameroun à la RCA. La logistique reste un pilier. Produits : OnboardLearning.org, Galababa.com et KesseDesk.'
    : 'Groupe Ouambo is a technology & digitalization group building AI-enabled platforms for education, commerce, and operations — with on-ground delivery from Cameroon to CAR. Logistics remains a pillar. Products: OnboardLearning.org, Galababa.com and KesseDesk.'

  return (
    <footer className="footer-v2">
      <div className="footer-v2-inner">

        {/* Brand column */}
        <div className="footer-v2-brand">
          <div className="footer-v2-logo-row">
            <img src={logo} alt="Groupe Ouambo" className="footer-v2-logo" />
            <div>
              <div className="footer-v2-name">Groupe Ouambo</div>
              <div className="footer-v2-slogan">{slogan}</div>
            </div>
          </div>
          <p className="footer-v2-desc">{description}</p>
          <div className="footer-v2-socials">
            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="footer-v2-social">in</a>
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="footer-v2-social">f</a>
            <a href="https://www.x.com" target="_blank" rel="noreferrer" aria-label="X" className="footer-v2-social">𝕏</a>
          </div>
        </div>

        {/* Services column */}
        <div className="footer-v2-col">
          <h4 className="footer-v2-col-title">{lang === 'fr' ? 'Services' : 'Services'}</h4>
          <ul className="footer-v2-links">
            <li><Link to="/technology">{t.nav?.technology || 'Technology & AI'}</Link></li>
            <li><Link to="/technology#platforms">{t.nav?.platforms || 'Digital platforms'}</Link></li>
            <li><Link to="/technology#energy">{t.nav?.energy || 'Energy'}</Link></li>
            <li><Link to="/transport">{t.nav?.transport || 'Logistics & corridor'}</Link></li>
            <li><Link to="/investment">{t.nav?.investment || 'Investment'}</Link></li>
          </ul>
        </div>

        {/* Company column */}
        <div className="footer-v2-col">
          <h4 className="footer-v2-col-title">{lang === 'fr' ? 'Entreprise' : 'Company'}</h4>
          <ul className="footer-v2-links">
            <li><Link to="/about">{t.nav?.about || 'About Us'}</Link></li>
            <li><Link to="/careers">{t.nav?.careers || 'Careers'}</Link></li>
            <li><Link to="/contact">{t.nav?.contact || 'Contact'}</Link></li>
          </ul>
        </div>

        {/* Contact column */}
        <div className="footer-v2-col">
          <h4 className="footer-v2-col-title">{lang === 'fr' ? 'Contact' : 'Contact'}</h4>
          <ul className="footer-v2-links footer-v2-contact">
            <li><span>📧</span><a href="mailto:info@groupeouambo.com">info@groupeouambo.com</a></li>
            <li><span>📍</span><span>{lang === 'fr' ? 'République Centrafricaine' : 'Central African Republic'}</span></li>
            <li><span>🌐</span><span>groupeouambo.com</span></li>
          </ul>
        </div>

      </div>

      <div className="footer-v2-bottom">
        <span>&copy; {year} Groupe Ouambo. {lang === 'fr' ? 'Tous droits réservés.' : 'All rights reserved.'}</span>
        <span className="footer-v2-bottom-right">
          <Link to="/contact">{lang === 'fr' ? 'Confidentialité' : 'Privacy'}</Link>
          <span>·</span>
          <Link to="/contact">{lang === 'fr' ? 'Conditions' : 'Terms'}</Link>
        </span>
      </div>
    </footer>
  )
}

export default Footer
